<template>
	<div class="personHome">
		<!-- 左侧产品列表 -->
		<div class="psLeftContent">
			<!-- 问题反馈 -->
			<div class="item w100">
				<div class="text bd10 p3">
					<div class="sTitle d-flex a-center j-sb">
						 <h3 class="font20">{{ $t('adminMenu.feedback') }}</h3>
						 <div class="btn">
							<el-button icon="el-icon-plus" type="primary" @click="goToPage('/feedback')">{{$t('commom.add')}}</el-button>
						 </div>
					</div>
					<div class="table font-light line-mn">
						<dl>
							<dt class="d-flex">
								<span>{{ $t('admin.questionType') }}</span>
								<span>{{ $t('admin.workOrderId') }}</span>
								<span>{{ $t('admin.nameAndVersion') }}</span>
								<span class="nowrap2">{{ $t('admin.workOrderTitle') }}</span>
								<span class="tcenter">{{ $t('feedback.ExpectedPriority') }}</span>
								<span class="tcenter">{{ $t('admin.problemStatus') }}</span>
								<span class="dt">{{ $t('admin.submissionTime') }}</span>
								<span class="tcenter">{{ $t('admin.operate') }}</span>
							</dt>
							<dd class="d-flex pointer" @click="goToPage('/problemDetail?id='+item.id)"  v-for="(item, index) in feedbackVoList" :key="index">
								<span>{{item.type}}</span>
								<span>{{ item.workItemId }}</span>
								<span>{{(item.productName||'')+' '+(item.versionNo||'')}}</span>
								<span class="nowrap2"><a class="link pointer">{{item.title}}</a></span>
								<span class="tcenter">{{item.costomerPriority|valueToLabel(selectPriority)}}</span>
								<span class="tcenter">{{item.status}}</span>
								<span class="dt">{{item.submitDate}}</span>
								<span class="d-flex tcenter j-center a-center">
									<a class="d" @click="goToPage('/problemDetail?id='+item.id)"></a>
								</span>
							</dd>
						</dl>
					</div>
				</div>
				<!-- 分页 -->
				<div class="pagination">
					 <el-pagination
						   @current-change="handleCurrentChange"
						   :page-size="10"
						   layout="prev, pager, next"
						   :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
export default {
  name: 'ProblemFeedback',
  components: {
    
  },
  data() {
    return {
		selectPriority:[],
		// 问题反馈
		feedbackVoList: [],
		// 分页
		pagination: {
			pageNo: 1,
			pageSize: 10
		},
		// 数量
		total: 0
	}
  },
  
  created() {
  	  // 获取问题反馈
	  this.getCostomerPriority();
  	  this.getFeedbackVoList();
  },
  filters:{
	valueToLabel:function(value,arr){
		if(value!=null&&arr&&arr.length>0){
			var a=arr.filter(i=>{return i.value==value});
			return a[0]?.label||'';
		}else{
			return ''
		};
		
	}
  },
  methods: {
	getCostomerPriority(){//获取优先级数据字典
		this.$axios.get(`common/getDict?dictType=sys_feedback_priority`)
		  .then(res => {
			  this.selectPriority=res.data;
		  })
		  .catch(err=>{})
	  },
  	 // 获取问题反馈
  	 getFeedbackVoList() {
		  this.$axios.post('member/feedbackPage', this.pagination)
		  .then(res => {
			  this.feedbackVoList = res.data.list;
			  this.total = res.data.total;
		  })
		  .catch(err => {})
  	 },
  	 
  	 // 页面跳转
  	 goToPage(path, query={}) {
		  this.$router.push({
			path,
			query
		  })
  	 },
  	 
  	 // 点击翻页
  	 handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getFeedbackVoList();
  	 }
  }
}
</script>

<style lang="less" scoped>
	.personHome{
		
		.psLeftContent{
			width: 100%;
			.toPage{
				margin-left: .15rem;
				input{
					width: .4rem;
					height: .4rem;
					border-radius: 5px;
					background: #fff;
					text-align: center;
					margin: 0 5px;
					padding: 0 5px;
				}
			}
			.item{
				width: 50%;
				margin-bottom: .2rem;
				&.w100{
					width: 100%;
					dd:hover,dd:hover a{
						color: #2657db;
					}
				}
			}
			.table{
				dl{
					dt,dd{
						padding: .22rem 0;
					}
					dt{
						background: #f2f5fa;
						border-radius: 5px;
						span:nth-of-type(1) {
							padding-left: .15rem;
						}
					}
					dd{
						&:not(:last-child) {
							border-bottom: solid 1px #eee;
						}
						span:nth-of-type(1) {
							position: relative;
							padding-left: .2rem;
							&:after{
								content: "";
								position: absolute;
								left: 0;
								top: .1rem;
								width: .04rem;
								height: .04rem;
								background: #2657db;
							}
						}
					}
					span{
						.d{
							width: .19rem;
							height: .14rem;
							background: url(@/assets/Icons/look.png) no-repeat center/100% 100%; 
							&:hover{
								background-image: url(@/assets/Icons/lookBlue.png);
							}
						}
						width: 12%;
						padding: 0 0.5em;
						flex: 0 0 auto;
						&.nowrap2{
							width: 16%;
						}
						&.tcenter{
							text-align: center;
						}
					}
				}
			}
		}
		@media (max-width: 768px) {
			padding: .2rem;
			.psLeftContent{
				.table{
					overflow: auto;
					dl{
						min-width: 768px;
						dt{
							span{
								text-align: center;
								&.nowrap2{
									text-align: left;
								}
							}
						}
						dd{
							span{
								text-align: center;
								&.nowrap2{
									text-align: left;
								}
							}
						}
					}
				}
			}
		}
	}
</style>
